export const social_media_data = [
    { class: "bi bi-facebook", name: "Facebook", url: "https://www.facebook.com/okaf24" },
    { class: "bi bi-twitter", name: "Twitter", url: "https://twitter.com/okaf24" },
    { class: "bi bi-instagram", name: "Instagram", url: "https://www.instagram.com/okaf24" },
    { class: "bi bi-linkedin", name: "Linkedin", url: "https://www.linkedin.com/company/okaf24/" },
    { class: "bi bi-youtube", name: "Youtube", url: "https://www.youtube.com/@okaf24" },
]